/*
 * Module for attributeList
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./attributeListView",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Backbone, Messenger, AttributeListView, SelectableListModule) {
  var AttributesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "attributes";
      this.namespace = options.namespace;
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.layout = new AttributeListView.attributeListLayout();

      this.list = this.addSubModule(
        new SelectableListModule({
          namespace: this.namespace,
          region: this.layout.list,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this.list.show(this.attributes);
        },
        this,
      );

      this._setupView();
    },

    focus: function () {
      if (this.isOpen && this.list) {
        this.list.focus();
      }
    },

    _setupView: function () {
      var activeKb = Messenger.reqres.request("active:kb");
      this.attributes = Messenger.reqres.request("fetch:kb:attributes", activeKb);
      this.attributes.onSynced(function () {
        this.showRegion(this.layout);
      }, this);
    },
    /*
     * Selects the variable in the list with the provided variable Id
     */
    setSelected: function (id) {
      this.attributes.onSynced(function () {
        var attribute = this.attributes.get(id);
        if (attribute) {
          this.list.selectItem(attribute);
        }
      }, this);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        Messenger.getFullName("list:item:selected", this.namespace),
        function (model) {
          Messenger.vent.trigger(
            Messenger.getFullName("show:attributeInfo", this.namespace),
            model,
          );
        },
        this,
      );
    },
  });

  return AttributesController;
});
